import API_BASE_URL from "../utils/config";
import request from "../utils/request";

export async function httpGetFeedback(data) {
  const url = `${API_BASE_URL}/flagged-questions`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function httpPostFeedback(data) {
  const { id, resolved } = data;
  const url = `${API_BASE_URL}/flagged-questions/${id}/resolve`;
  return request({
    url,
    method: "post",
    data: { resolved },
  });
}
